import React, { memo, type PropsWithChildren } from 'react';
import { VStack } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientsList = memo(
  (props: PropsWithChildren) => {
    return <VStack gap={0}>{props.children}</VStack>;
  },
);
